'use strict';

import angular from 'angular';
import CodeController from './code.controller';

export default angular.module('onyxReadingRoomApp.appconfs.code', [])
  .controller('AppConfsCodeController', CodeController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfs/code/index.js